export interface SetCustomFieldBlockModelInterface {
    sourceFieldColName: string;   // dropdown 1 selection (source custom form field)
    sourceDisplayValue: string;   // dropdown 1 label incl. type suffix
    targetFieldColName: string;   // dropdown 2 selection (object custom field)
    targetDisplayValue: string;   // dropdown 2 label incl. type suffix
    overrideExisting: boolean;    // override checkbox
}

export class SetCustomFieldBlockModel implements SetCustomFieldBlockModelInterface {
    sourceFieldColName: string = '';
    sourceDisplayValue: string = '';
    sourceFieldType: string = '';
    sourceFieldAnswerType: string = '';
    targetFieldColName: string = '';
    targetDisplayValue: string = '';
    targetFieldTemplateId: number = undefined;
    targetFieldType: string = '';
    targetFieldAnswerType: string = '';
    formTemplateId: number = undefined;
    overrideExisting: boolean = false;

    constructor(data: {} = undefined) {
        if (data) {
            this.sourceFieldColName = data['sourceFieldColName'] ? data['sourceFieldColName'] : '';
            this.sourceDisplayValue = data['sourceDisplayValue'] ? data['sourceDisplayValue'] : '';
            this.sourceFieldType = data['sourceFieldType'] ? data['sourceFieldType'] : '';
            this.sourceFieldAnswerType = data['sourceFieldAnswerType'] ? data['sourceFieldAnswerType'] : '';
            this.targetFieldColName = data['targetFieldColName'] ? data['targetFieldColName'] : '';
            this.targetDisplayValue = data['targetDisplayValue'] ? data['targetDisplayValue'] : '';
            this.targetFieldTemplateId = data['targetFieldTemplateId'] ? data['targetFieldTemplateId'] : '';
            this.targetFieldType = data['targetFieldType'] ? data['targetFieldType'] : '';
            this.targetFieldAnswerType = data['targetFieldAnswerType'] ? data['targetFieldAnswerType'] : '';
            this.formTemplateId = data['formTemplateId'] ? data['formTemplateId'] : undefined;
            this.overrideExisting = !!data['overrideExisting'];
        }
    }
}
